import { fallbackNode } from '../../../renderers/node/nodeRenderer';
import type {
  GenericNodeAttributes,
  NodeAttributes,
} from '../../../types/node';
import type { Relation } from '../../../types/relation';

export const getNodeComponent = (
  nodeAttributes: Partial<NodeAttributes>,
  node: Relation,
): GenericNodeAttributes => {
  const { nodeType } = node;

  return nodeAttributes[nodeType] || fallbackNode;
};
